module.exports = __webpack_public_path__ + "img/SDG-09-EN.e6a9ba9d.png";